export const liveCountMarquee = [
  'Akshatha baliga from Dakshina Kannada just bought 3 diapers',
  'Adil khan from Kolkata just bought 3 diapers',
  'Rajib paul from North 24 Parganas just bought 3 diapers',
  'Marichamy  from Madurai just bought 3 diapers',
  'Muhsina Thasnim from Thrissur just bought 3 diapers',
  'soniaranigmailcom  from Karnal just bought 3 diapers',
  'Kasireddy Shravani from Tadipatri just bought 3 diapers',
  'Ravi Kushwaha from Lucknow just bought 3 diapers',
  'Nimshad  from Malappuram just bought 3 diapers',
  'Faseela renil from Thrissur just bought 3 diapers',
  'Fouziya  from Ananthapur just bought 3 diapers',
  'Kiran soni from Churu just bought 3 diapers',
  'Sowmiya  from Tiruvarur just bought 3 diapers',
  'Akshaya  from Nirmal just bought 3 diapers',
  'Neethu Thomas from Dakshina Kannada just bought 3 diapers',
  'Piyush Anand from Kanpur Nagar just bought 3 diapers',
  'Seyon Karthi from Kanchipuram just bought 3 diapers',
  'Piya Patel from Kachchh just bought 3 diapers',
  'Lourdemary  from Pondicherry just bought 3 diapers',
  'Balvir kaur from Ropar just bought 3 diapers',
  'Vivek Kumar from Ramgarh just bought 3 diapers',
  'Aswathi Bijeesh from Kozhikode just bought 3 diapers',
  'Priyanka Gajbe from Takhatpur  just bought 3 diapers',
  'Suman  from Lucknow just bought 3 diapers',
  'Nirmala Chetan from Chickmagalur just bought 3 diapers',
  'Jabirul Haque from Darrang just bought 3 diapers',
  'Amit kapoor from Ranchi just bought 3 diapers',
  'Shahid  from Bangalore just bought 3 diapers',
  'Sana patil from Pune just bought 3 diapers',
  'SUJATA SHARMA from Gorakhpur just bought 3 diapers',
  'Roopesh Bhandari from Uttara Kannada just bought 3 diapers',
  'Suganya Sivasamy from Coimbatore just bought 3 diapers',
  'Nancy X from Tiruvallur just bought 3 diapers',
  'Ruksana Khan from  didwana Nagaur just bought 3 diapers',
  'Shrinithi  from Namakkal just bought 3 diapers',
  'Tanu  from Thane Central just bought 3 diapers',
  'Priyambada Samantaray from Khorda just bought 3 diapers',
  'Pradeep jaiswal from Gorakhpur just bought 3 diapers',
  'Tajalli Patel from Mumbai just bought 3 diapers',
  'Bomak sera from West Siang just bought 3 diapers',
  'Hiren desai from Surat just bought 3 diapers',
  'Pranali Fengade from Amravati just bought 3 diapers',
  'Durgesh Pratap from Udham Singh Nagar just bought 3 diapers',
  'Monika M from Bangalore just bought 3 diapers',
  'S S from Jorhat just bought 3 diapers',
  'Sandeep Jaiswal from Chandauli just bought 3 diapers',
  'SHIRISH TADADIKAR from South Goa just bought 3 diapers',
  'Suba Sekar from Chittoor just bought 3 diapers',
  'Abshad  from Kollam just bought 3 diapers',
  'Sagar Yeshwante from Mumbai just bought 3 diapers',
  'kokkikumar  from Kallakurchi  just bought 3 diapers',
  'Sushila Chettri from East Sikkim just bought 3 diapers',
  'Binod kumar from Dhanbad just bought 3 diapers',
  'Anjana Vasoya from Jamnagar just bought 3 diapers',
  'Arun  from Madurai just bought 3 diapers',
  'Kirti Parth from Agra just bought 3 diapers',
  'Hinal patel from Surat just bought 3 diapers',
  'Ashmi Semalni from Mumbai just bought 3 diapers',
  'Kiruba V from Pudukkottai just bought 3 diapers',
  'Sugendran  from Kanyakumari just bought 3 diapers',
  'Pranay Chhetri from Darjiling just bought 3 diapers',
  'Burra kranthi from Karim Nagar just bought 3 diapers',
  'Shahid Ghori from Sikar just bought 3 diapers',
  'Sanjay Basfor from Kamrup just bought 3 diapers',
  'Vipin Sharma from South Delhi just bought 3 diapers',
  'Karakam srikanth from West Godavari just bought 3 diapers',
  'Aparna Chaturvedi from Bilaspur(CGH) just bought 3 diapers',
  'Nandini  from Bangalore just bought 3 diapers',
  'Raju  from Bangalore just bought 3 diapers',
  'Jyothi  from Raichur just bought 3 diapers',
  'Ravi Singh from Lucknow just bought 3 diapers',
  'Anjumol chacko from Kottayam just bought 3 diapers',
  'Jyotiba Satpute from Sangli just bought 3 diapers',
  'Sukanya  from Bangalore just bought 3 diapers',
  'Kapil Agarwal from Howrah just bought 3 diapers',
  'Sridhar Rao from Bangalore just bought 3 diapers',
  'Sumanta roy from Gangarampur  just bought 3 diapers',
  'Mahendra  from Tiruvallur just bought 3 diapers',
  'P V from Visakhapatnam just bought 3 diapers',
  'Rohini  from Ghaziabad just bought 3 diapers',
  'ANWAR khan from Hazaribag just bought 3 diapers',
  'pardeep singh from Ludhiana just bought 3 diapers',
  'Akhil S from Thiruvananthapuram just bought 3 diapers',
  'Uarvashi Poonia from Rohtak just bought 3 diapers',
  'GANESH AGENCY from Gadag just bought 3 diapers',
  'shalu  from Gautam Buddha Nagar just bought 3 diapers',
];

// export const liveDataMarquee = liveCountMarquee.map((data) => {
//     const copyData = [...liveCountMarquee];
//     const size = liveCountMarquee.length;
//     return { text: data };
// });

export const liveDataMarquee = () => {
  const copyData = [...liveCountMarquee];
  const size = liveCountMarquee.length;

  const randomData = [];
  for (let i = 0; i < size; i++) {
    let indexPick = Math.floor(Math.random() * copyData.length);
    const returnData = copyData[indexPick];
    copyData.splice(indexPick, 1);
    randomData.push({ text: returnData });
  }

  return randomData;
};

export const randomOrder = (randomArr, maxSize) => {
  const copyData = [...randomArr];
  const size = randomArr.length;

  const randomData = [];
  for (let i = 0; i < size; i++) {
    let indexPick = Math.floor(Math.random() * copyData.length);
    const returnData = copyData[indexPick];
    copyData.splice(indexPick, 1);
    randomData.push(returnData);
  }
  if (maxSize || maxSize == 0) return randomData.slice(0, maxSize);
  return randomData;
};
